module.exports = __webpack_public_path__ + "assets/img/guanggao.0d15f8b2.png";